export default __webpack_public_path__ + "static/negz-0718a6429422f32da80b4a24c8b9bd46.jpg";